export default [
  {
    name: `instruction_1`,
    title: `손가락을 슬라이드하여 360° 주위를 봅니다.`,
  },
];
